// When a property's compliance review passed, and who passed it.
//
// Shared by the property's own Compliance tab and the offering details
// Property tab, so both screens read approval off the same rule.
import { PROPERTY_STATUS } from '../constants/propertyStatus'
import type { AuditLog } from '../types/propertyTypes'

// Reaching the VASP stage (or beyond) means compliance has been approved.
const COMPLIANCE_APPROVED_STATUSES: string[] = [
  PROPERTY_STATUS.IN_VASP,
  PROPERTY_STATUS.SENT_TO_VASP,
  PROPERTY_STATUS.APPROVED,
  PROPERTY_STATUS.ARCHIVED,
]

export function isComplianceApprovedStatus(status: string | null | undefined): boolean {
  return COMPLIANCE_APPROVED_STATUSES.includes((status ?? '').toLowerCase())
}

export function isComplianceInReviewStatus(status: string | null | undefined): boolean {
  return (status ?? '').toLowerCase() === PROPERTY_STATUS.IN_COMPLIANCE
}

/**
 * The audit entry for the compliance approval. The log's `action` is the status
 * entered, so approval is the move from in_compliance into in_vasp. Matching on
 * "compliance"/"approv" words never found it, leaving "Approved by / on" blank
 * (VA-01).
 */
export function findComplianceApproval(logs: AuditLog[] | null | undefined): AuditLog | null {
  return (
    (logs ?? []).find(
      (log) =>
        log.action === PROPERTY_STATUS.IN_VASP && log.fromStatus === PROPERTY_STATUS.IN_COMPLIANCE,
    ) ?? null
  )
}
